import CommonState from './commonState';

const state: CommonState = {
  analyticsConsent: false,
  language: 'en',
};

export default state;
